<h1>Albion Online Crafting and Refining Calculator</h1>
<!-- MARK: Entitlements -->

<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" animationDuration="100">
  <mat-tab label="Intro">
    <ng-template matTabContent>
      <app-craft-calculator-intro></app-craft-calculator-intro>
    </ng-template>
  </mat-tab>
  <mat-tab label="Load & Save">
    <ng-template matTabContent>
      <app-craft-calculator-load-save></app-craft-calculator-load-save>
    </ng-template>
  </mat-tab>
  <mat-tab label="Setup">
    <ng-template matTabContent>
      <app-craft-calculator-setup></app-craft-calculator-setup>
    </ng-template>
  </mat-tab>
  <mat-tab label="Inputs">
    <ng-template matTabContent>
      <app-craft-calculator-prices></app-craft-calculator-prices>
    </ng-template>
  </mat-tab>
  <mat-tab label="Outputs">
    <ng-template matTabContent>
      <app-craft-calculator-prices-outputs></app-craft-calculator-prices-outputs>
    </ng-template>
  </mat-tab>
  <mat-tab label="Specs">
    <ng-template matTabContent>
      <app-craft-calculator-specs></app-craft-calculator-specs>
    </ng-template>
  </mat-tab>
  <mat-tab label="Results">
    <ng-template matTabContent>
      <app-craft-calculator-results></app-craft-calculator-results>
    </ng-template>
  </mat-tab>
  <mat-tab label="Shopping List">
    <ng-template matTabContent>
      <app-craft-calculator-shopping></app-craft-calculator-shopping>
    </ng-template>
  </mat-tab>
  <mat-tab label="Selling List">
    <ng-template matTabContent>
      <app-craft-calculator-selling></app-craft-calculator-selling>
    </ng-template>
  </mat-tab>
</mat-tab-group>
